export function Mouseover() {
    // console.log("进入 悬停区域");
    this.activecolor = "color:#78aad1"; // 进入 悬停区域,更改文字颜色
    // this.showTooltip=true;
}

// 鼠标"离开"触发此方法
export function Mouseleave() {
    // console.log("离开 悬停区域");
    this.activecolor = "color: #3675aa"; // 离开 悬停区域,文字颜色复原
    // this.showTooltip=false;
}
export function buttonMouseover(e) {
    this.buttonStyle = false;
    var id = e.currentTarget.id;
    if (id == "button41") {
        this.buttonID = 1;
    } else if (id == "button42") {
        this.buttonID = 2;
    } else if (id == "button43") {
        this.buttonID = 3;
    } else {
        this.buttonID = 4;
    }
}
export function buttonMouseleave() {
    this.buttonStyle = true;
    this.buttonID = 0;
}
export function changeLiShow() {
    this.liShow = !this.liShow;
}
export function downloadFile(url, fileName) {
    const fileUrl = url; // 文件的URL地址
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', fileName);
    link.click();
}
export function selectOne(item) {     //change 触发事件
    $('#' + item[0] + 'iframe').attr('src', '/geo' + item + '.html');
}